export const GuangzhouHref = { name: 'Guangzhou Notice', href: 'notice://f305c793-ae9c-434f-a5d8-2b3b79e2b2fb' }

export const NoticeHref = { name: 'apM Ad Notice', href: 'notice://4e354c0b-8533-4f0d-8bd4-03e400ec06e3' }

export const DongnaeHref = { name: 'Dongnae', href: 'webview://dongnae.com/en' }

export const OpnegHref = { name: 'Opneg', href: 'webview://m.opneg.com/' }

export const MomeHref = { name: 'Mome', href: 'webview://www.momemoment.com/' }

export const IksanHref = { name: 'Iksan', href: 'webview://msandan.com/' }

export const FffBakeryHref = { name: 'Fffbakery', href: 'webview://smartstore.naver.com/crofflehouse/products/6273793522' }

export const EliotHref = { name: 'Eliot', href: 'webview://app.catchtable.co.kr/ct/shop/Elliot' }

export const SbtHref = { name: 'Sbt', href: 'event://67aeed55-9809-40db-b9e3-565c907e7d02' }

export const EventHref = 'event://8f8c3890-5526-46a0-bb0c-6dca00ba8cff'

export const WebviewHref = 'webview://apm-members.com'

export const musicalSchoolOfRockHref = { name: 'Musical School of rock', href: 'webview://store.xticket.io/SOR-KR2024' }

export const membershipCouponHref = { name: 'Membership Coupon', href: 'notice://609b9958-7d5d-4558-9569-bb8781c1dc30' }

export const regenPlasticSurgery = { name: 'Regen Plastic Surgery', href: 'webview://ad.apm-members.com/regen' }

export const diamondHref = { name: 'Diamond', href: 'notice://201c0f50-4448-4a5c-bddb-fe0e36a5eb0d' }

export const mediumBusinessHref = { name: 'Medium Business', href: 'notice://179c0d70-9728-423a-8b9a-ff262004ae16' };

export const smallBusinessHref = { 
  name: 'Small Business', 
  href: {
    kor: 'notice://e48a5124-c181-45df-96c3-c466a768e780',
    eng: 'notice://e48a5124-c181-45df-96c3-c466a768e780',
    chi: 'notice://e48a5124-c181-45df-96c3-c466a768e780'
  }
};

export const diamondVoucherHref = { 
  name: 'Diamond Voucher', 
  href: {
    kor: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html',
    eng: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html',
    chi: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html'
  }
}

export const fashionHref = { 
  name: 'Fashion Association', 
  href: {
    kor: 'notice://274947eb-3935-4245-a1ee-aac1b5264d1b',
    eng: 'notice://274947eb-3935-4245-a1ee-aac1b5264d1b',
    chi: 'notice://274947eb-3935-4245-a1ee-aac1b5264d1b'
  }
};

export const saemaeulHref = { 
  name: 'Saemaeul', 
  href: {
    kor: 'notice://4c0edef6-3d4a-47b5-9661-f2b0efc8b791',
    eng: 'notice://4c0edef6-3d4a-47b5-9661-f2b0efc8b791',
    chi: 'notice://4c0edef6-3d4a-47b5-9661-f2b0efc8b791'
  }
};

export const discountVoucherHref = { 
  name: 'Discount Voucher (1%)', 
  href: {
    kor: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html',
    eng: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html',
    chi: 'webview://cdn.apm-members.com/redirect/apm-members-diamond-sale.html'
  }
}

const getLandingHref = () => {
  if (process.env.REACT_APP_ENV === 'PROD') return 'landing'
  return 'stg-landing'
}

export const telecomHref = { 
  name: 'Telecom', 
  href: {
    kor: `webview://${getLandingHref()}.apm-members.com/telecom?language=kor`,
    eng: `webview://${getLandingHref()}.apm-members.com/telecom?language=eng`,
    chi: `webview://${getLandingHref()}.apm-members.com/telecom?language=chi`
  }
};

export const tripDotComHref = {
  name: 'Trip.com',
  href: {
    kor: 'webview://trip.com/t/8PO5UKIIsR2',
    eng: 'webview://trip.com/t/c3YbejDIsR2',
    chi: 'webview://trip.com/t/3mb8rDJIsR2',
  }
}

export const apMTradingHref = {
  name: 'apM Trading',
  href: {
    kor: 'webview://www.lbank.com/support/articles/2016025139799392256',
    eng: 'webview://www.lbank.com/support/articles/2016025139799392256',
    chi: 'webview://www.lbank.com/support/articles/2016025139799392256',
  }
}

export const exchangeHref = {
  name: 'Exchange',
  href: {
    kor: 'webview://apm.oopy.io/2fca619b-961a-8045-acaf-fb0fe3a724ee',
    eng: 'webview://apm.oopy.io/2fca619b-961a-8045-acaf-fb0fe3a724ee',
    chi: 'webview://apm.oopy.io/2fca619b-961a-8045-acaf-fb0fe3a724ee',
  }
}

export const irisHref = {
  name: 'Iris',
  href: {
    kor: 'webview://apm.oopy.io/305a619b-961a-8078-a290-e812ff9c1735',
    eng: 'webview://apm.oopy.io/305a619b-961a-8078-a290-e812ff9c1735',
    chi: 'webview://apm.oopy.io/305a619b-961a-80f9-b4b4-f12ddf809e8b',
  }
}
